import Swiper, {
  Parallax,
  Navigation,
  EffectFade,
  Controller,
  Thumbs,
} from 'swiper'

import 'swiper/css'
import 'swiper/css/parallax'

Swiper.use([Parallax, Navigation, EffectFade, Controller, Thumbs])

export default function() {
  const section = document.querySelector('.home-hero-section')

  const contentSlider = new Swiper(
    section.querySelector('.home-hero-content-slider'),
    {
      slidesPerView: 1,
      effect: 'fade',
      speed: 1000,
      allowTouchMove: false,
    }
  )

  new Swiper(section.querySelector('.home-hero-img-slider'), {
    slidesPerView: 1,
    watchSlidesProgress: true,
    parallax: true,
    speed: 800,

    controller: {
      control: contentSlider,
    },
    thumbs: {
      swiper: contentSlider,
    },

    navigation: {
      prevEl: section.querySelector('.swiper-button-prev'),
      nextEl: section.querySelector('.swiper-button-next'),
    },

    on: {
      transitionStart: () => {
        section
          .querySelector('.swiper-button-prev')
          .setAttribute('disabled', true)
        section
          .querySelector('.swiper-button-next')
          .setAttribute('disabled', true)
      },
      transitionEnd: () => {
        section.querySelector('.swiper-button-prev').removeAttribute('disabled')
        section.querySelector('.swiper-button-next').removeAttribute('disabled')
      },
    },
  })
}
